"use client";
import React, { useState, useEffect,useContext } from 'react';
import { ProductContext } from './Productcontext';
// import { Link,useNavigate } from 'react-router-dom';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import gicon from '../images/Group 7013.svg'
import fb from '../images/facebook.svg'
import wa from '../images/whatsapp.svg'
import tr from '../images/twitter-sign.svg'
import ln from '../images/linked_in.svg';
import ins from '../images/instagram.svg';
import grass from '../images/grass-1x.jpg';
import grass2x from '../images/grass-2x.jpg';
import Image from 'next/image';

const Footer = ({ backgroundColor = 'white', linedisp }) => {
//   let navigate = useNavigate();
const router = useRouter();
//   const [footerItems, setFooterItems] = useState([]);
  const {setCategory, setProduct} = useContext(ProductContext);
  const [isOpen, setIsOpen] = useState(false); // Hamburger menu state
  const [footeractiveItem, setFooteractiveItem] = useState('');

  // // Initialize activeItem from localStorage (if it exists)
  // const [footeractiveItem, setFooteractiveItem] = useState(() => {

  //   if (typeof window !== 'undefined') {
  //     return localStorage.getItem('footeractiveItem') || '';
  //   }
  //   return '';
  // });

  // Set the initial value after the component mounts (client-side)
useEffect(() => {
  if (typeof window !== 'undefined') {
    // const storedItem = localStorage.getItem('footeractiveItem') || '';
    const storedItem = localStorage.getItem('footeractiveItem');
    setFooteractiveItem(storedItem);
  }
}, []);

// Update `footeractiveItem` in localStorage whenever it changes
useEffect(() => {
  if (footeractiveItem) {
    localStorage.setItem('footeractiveItem', footeractiveItem);
  }
}, [footeractiveItem]);

// useEffect(() => {
//   const handleClearFooter = () => {
//     setFooteractiveItem('');
//     localStorage.setItem('footeractiveItem', '');
//   };

//   window.addEventListener('clearFooterItem', handleClearFooter);

//   return () => {
//     window.removeEventListener('clearFooterItem', handleClearFooter);
//   };
// }, []);


// useEffect(() => {
//   // Check for `localStorage` only on the client side
//   const storedActiveItem = localStorage.getItem('activeItem');
//   if (storedActiveItem) {
//     setActiveItem(storedActiveItem);
//   } else {
//     setActiveItem('slpr'); // Set the default active item after the component mounts
//   }
// }, []); // Run only once after the initial render

// Store `activeItem` in `localStorage` whenever it changes
// useEffect(() => {
//   if (footeractiveItem) {
//     localStorage.setItem('footeractiveItem', footeractiveItem);
//   }
// }, [footeractiveItem]);

  // useEffect(() => {
  //   // Check for `localStorage` only on the client side
  //   const storedActiveItem = localStorage.getItem('activeItem');
  //   if (storedActiveItem) {
  //     setActiveItem(storedActiveItem);
  //   } else {
  //     setActiveItem('slpr'); // Set the default active item after the component mounts
  //   }
  // }, []); // Run only once after the initial render
  
  // // Store `activeItem` in `localStorage` whenever it changes
  // useEffect(() => {
  //   if (activeItem) {
  //     localStorage.setItem('activeItem', activeItem);
  //   }
  // }, [activeItem]);



  const toggleMenu = () => setIsOpen(!isOpen); // Toggle menu function

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scrolling animation
    });
  };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch('/data/footerItems.json');
//         const data = await response.json();
//         setFooterItems(data);
//       } catch (error) {
//         console.error('Error fetching footer items:', error);
//       }
//     };

//     fetchData();
//   }, []);

  const handleItemClick = (item) => {
    // Ensure router works only in the browser


    if (typeof window !== 'undefined') {
      console.log(" item is "+item);
      setFooteractiveItem(item); 
      localStorage.setItem('activeItem', '');
      setCategory(item);
      localStorage.setItem('selectedCategory', item);
        
      console.log("handleItemClick active item="+localStorage.getItem('footeractiveItem'));
    if(item==='slpr')
    {
      // setCategory('slpr');
      // localStorage.setItem('selectedCategory', 'slpr');
      localStorage.setItem('footeractiveItem', item);
        router.push('/ashlok-lightning-protection-systems');
    }
    else if(item=='clp')
    {
      // setCategory('clp');
      // localStorage.setItem('selectedCategory', 'clp');
      localStorage.setItem('footeractiveItem', item);
          router.push('/ashlok-conventional-lightning-protection');

    }
    else if(item=='ele')
    {
      // setCategory('ele');
      // localStorage.setItem('selectedCategory', 'ele');
      localStorage.setItem('footeractiveItem', item);
        router.push('/ashlok-safe-earthing-electrodes');
    }
    else if(item=='bfc')
    {
      // setCategory('bfc');
      // localStorage.setItem('selectedCategory', 'bfc');
      localStorage.setItem('footeractiveItem', item);
        router.push('/ashlok-baron-backfill-compound');
    }
    else if(item=='epcc')
    {
      // setCategory('epcc');
      // localStorage.setItem('selectedCategory', 'epcc');
      localStorage.setItem('footeractiveItem', item);
        router.push('/ashlok-earthpit-chamber-cover');
    }
    
    else if(item=='spd')
    {
      //setCategory('slpr');
      //setProduct('spd');
      localStorage.setItem('selectedCategory', 'slpr');
      localStorage.setItem('footeractiveItem', item);
      router.push('/ashlok-surge-protection-device');
    }
    else if(item=='exo_kit')
    {
      //setCategory('slpr');
      //setProduct('exo_kit');
      localStorage.setItem('selectedCategory', 'slpr');
      localStorage.setItem('footeractiveItem', item);
      router.push('/ashlok-exothermic-welding-kit');
    }
    scrollToTop();
}
   };

  return (
    <div>
      <footer>
        {linedisp && 
          <div className='w-full'>
            <Image className='mt-[-1px]' src={grass2x} alt="Underground earth view for earthing and grounding solutions by Ashlok Safe Earthing Electrode Limited"/>
           
          </div>
        }
        <div className='w-full bg-ashred text-white flex items-center h-1'>
        </div>
        {/* Hamburger button */}
        <div className="lg:hidden flex justify-end p-4">
          <button onClick={toggleMenu} className="text-ashblack">
            {/* Hamburger icon */}
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16m-7 6h7'} />
            </svg>
          </button>
        </div>
        
        <div className={`flex  bg-${backgroundColor}  text-ashblack pt-10 px-2 lg:px-0 ${isOpen ? 'block' : 'hidden'} lg:flex lg:flex-row`}>
          
          <section className='container mx-auto max-w-screen-xl flex flex-row text-sm  lg:text-base'>
            
            <div className={`flex flex-col  w-full lg:w-1/2  `} >
              <h2 className={` mb-2 flex text-2xl justify-start  text-ashblack font-extrabold`}>PRODUCT(<span style={{ fontSize: '80%' }}>s</span>)</h2>
              <div className="flex flex-wrap">
                <div className="w-full md:w-1/2">
                  <ul className={'justify-start flex flex-col flex-wrap'}>

                    <li className={`leading-9 flex-grow ${ footeractiveItem === 'slpr' ? ' bg-ashred2 text-white' : ' text-black'}`} ><span className='cursor-pointer' onClick={() => handleItemClick('slpr')}><span className="text-xl">S</span>AFE <span className="text-xl">L</span>IGHTNING <span className="text-xl">P</span>ROTECTION <span className="text-xl">R</span>OD(<span style={{ fontSize: '90%' }}>s</span>) </span></li>
                    <li className={`leading-9 flex-grow ${ footeractiveItem === 'clp' ? ' bg-ashred2 text-white' : 'text-black'}`} ><span className='cursor-pointer' onClick={() => handleItemClick('clp')}><span className="text-xl">C</span>ONVENTIONAL <span className="text-xl">L</span>IGHTNING <span className="text-xl">P</span>ROTECTION(<span style={{ fontSize: '90%' }}>s</span>)</span></li>
                    <li className={`leading-9 flex-grow ${ footeractiveItem === 'ele' ? ' bg-ashred2 text-white' : 'text-black'}`} ><span className='cursor-pointer' onClick={() => handleItemClick('ele')}><span className="text-xl">S</span>AFE <span className="text-xl">E</span>ARTHING <span className="text-xl">E</span>LECTRODE(<span style={{ fontSize: '90%' }}>s</span>)</span></li>


                  </ul>
                </div>

                <div className="w-full md:w-1/2">
                  <ul className={'justify-start flex flex-col flex-wrap'}>
                    <li className={`leading-9 flex-grow ${ footeractiveItem === 'bfc' ? ' bg-ashred2 text-white' : 'text-black'}`} ><span className='cursor-pointer' onClick={() => handleItemClick('bfc')}><span className="text-xl">B</span>ACKFILL <span className="text-xl">C</span>OMPOUND(<span style={{ fontSize: '90%' }}>s</span>)</span></li>
                    <li className={`leading-9 flex-grow ${ footeractiveItem === 'epcc' ? ' bg-ashred2 text-white' : 'text-black'}`} ><span className='cursor-pointer' onClick={() => handleItemClick('epcc')}><span className="text-xl">E</span>ARTHPIT <span className="text-xl">C</span>HAMBER <span className="text-xl">C</span>OVER(<span style={{ fontSize: '90%' }}>s</span>)</span> </li>



                  </ul>
                </div>
              </div>

            </div>
            <div className={`flex flex-col lg:flex-row  w-full lg:w-1/2`} >
                <div className={`flex flex-col w-1/2 `} >
                  <h2 className={` mb-2 flex text-2xl justify-start  text-white font-extrabold`}>EARTHING(<span style={{ fontSize: '80%' }}>s</span>)</h2>
                  <div className="">
                    <ul className={'justify-start flex flex-col flex-wrap'}>
                      <li className={`leading-9 flex-grow ${ footeractiveItem === 'exo_kit' ? ' bg-ashred2 text-white' : 'text-black'}`} ><span className='cursor-pointer' onClick={() => handleItemClick('exo_kit')}><span className="text-xl">E</span>XOTHERMIC <span className="text-xl">W</span>ELDING <span className="text-xl">K</span>IT</span> </li>
                      <li className={`leading-9 flex-grow ${ footeractiveItem === 'spd' ? ' bg-ashred2 text-white' : 'text-black'}`} ><span className='cursor-pointer' onClick={() => handleItemClick('spd')}><span className="text-xl">S</span>URGE <span className="text-xl">P</span>ROTECTION <span className="text-xl">D</span>EVICE(<span style={{ fontSize: '90%' }}>s</span>)</span> </li>
                    </ul>
                  </div>
                </div>
                  <div className={`flex flex-col w-1/2 `}>
                      
                     
                        <h2 className={` mb-2 flex text-2xl justify-start  text-ashblack font-extrabold`}> SERVICE(<span style={{ fontSize: '80%' }}>s</span>)</h2>

                        <ul className={'justify-start'}>

                          <li className={`leading-9 ${ footeractiveItem === 'ourservices#install' ? ' bg-ashred2 text-white' : 'text-black'}`} ><div><span className='cursor-pointer' onClick={() => handleItemClick('ourservices#install')}><Link href="/ourservices#install" onClick={scrollToTop}><span className="text-xl">I</span>NSTALLATION</Link></span></div> </li>
                          <li className={`leading-9 ${ footeractiveItem === 'ourservices#soil' ? ' bg-ashred2 text-white' : 'text-black'} `} ><div><span className='cursor-pointer' onClick={() => handleItemClick('ourservices#soil')}><Link href="/ourservices#soil" onClick={scrollToTop}><span className="text-xl">S</span>OIL-<span className="text-xl">T</span>ESTING</Link></span> </div></li>
                          <li className={`leading-9 ${ footeractiveItem === 'ourservices#design' ? ' bg-ashred2 text-white' : 'text-black'} `} ><div><span className='cursor-pointer' onClick={() => handleItemClick('ourservices#design')}><Link href="/ourservices#design" onClick={scrollToTop}><span className="text-xl">D</span>ESIGN & <span className="text-xl">C</span>OMMISSIONING</Link></span></div> </li>



                        </ul>



                  </div>
            </div>

            

          </section>
        </div>
        <div className={`w-full  bg-${backgroundColor}  text-ashred flex items-center pb-3 px-2 lg:px-0`}>
          <section className='container mx-auto max-w-screen-xl flex flex-row justify-end'>
          <Link href="https://www.facebook.com/profile.php?id=100068589324482" target="_blank" rel="noopener noreferrer"><Image src={fb} className='mx-2' alt="Ashlok fb" /></Link>         
          <Link href="https://www.linkedin.com/company/8507004/admin/inbox/thread/2-YjM4ZmE3ZjYtYmJhMy00NjRkLTk0MzItNWQxNDYyNjViZTY2XzAxMA==" target="_blank" rel="noopener noreferrer"><Image src={ln} className='mx-2' alt="Ashlok linked in" /></Link>         
          <Link href="https://www.instagram.com/ashlok_safe_earthing" target="_blank" rel="noopener noreferrer"><Image src={ins} className='mx-2' alt="Ashlok Instagram" /></Link>         
            
            
            
            {/* <Image src={wa} className='mx-2' alt="m5" /> */}
           
          </section>
        </div>
        <div className='w-full bg-ashred text-white flex items-center px-2 lg:px-0'>
          <section className='container mx-auto max-w-screen-xl '>
             <div className='flex flex-row'>
              <div className='flex basis-1/2 justify-start align-middle'>
                  <div className='text-white pt-2 pb-2 text-base sm-small:text-sm sm:text-sm md:text-base lg:text-xl'>© COPYRIGHT 2025 ASHLOK</div>
                </div>
                <div className='flex basis-1/2 justify-end flex-end pt-2 pb-2 text-base sm-small:text-sm sm:text-sm md:text-base lg:text-xl'>
                 
                <a href="https://salasarsolutions.com">DESIGNED BY   SALASAR TECHNOLOGIES</a>
                  </div>
            </div>
          </section>
        </div>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-M3M0QCE672"></script>
          <script
           id="google-analytics"
           strategy="afterInteractive"
           dangerouslySetInnerHTML={{
               __html: `
                   window.dataLayer = window.dataLayer || [];
                   function gtag(){dataLayer.push(arguments);}
                   gtag('js', new Date());
                   gtag('config', 'G-M3M0QCE672', {
                       page_path: window.location.pathname,
                   });
               `,
           }}
          /> 
      </footer>
    </div>
  );
};

export default Footer;
